// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"212": "06967479","366": "9154912f","74": "8c7773e1","985": "482cb750",}[chunkId] + ".css"
}